import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as dates from '@simplybenefits/sb-dates';
import { Loader, MessageCard, Text, AmendmentList, ContainerControlSite, Content } from '@simplybenefits/sb-ui-library';
import Header from '../../../components/Header.js';

import { getAccount, getAmendments, createAmendment } from '../../../actions/accounts.js';

class Amendments extends PureComponent {
    state = {
        amendments: null
    };

    async componentDidMount() {
        if (!this.props.currentAccountMeta) {
            await this.props.dispatch(getAccount(this.props.match.params.accountID));
        }

        const amendments = await this.props.dispatch(getAmendments(this.props.match.params.accountID));

        this.setState({
            amendments
        });
    }

    _buildBreadcrumbs = () => [
        {
            title: 'Accounts',
            link: `/accounts`
        },
        {
            title: this.props.currentAccountMeta.company,
            link: `/accounts/${ this.props.currentAccountMeta.accountID }`
        }
    ];

    _createAmendment = async () => {
        const amendmentID = await this.props.dispatch(createAmendment(this.props.currentAccountMeta.accountID));

        // on a create new amendment, we will create a blank amendment and open the edit form view
        if (amendmentID) {
            window.location.href = `/accounts/${ this.props.currentAccountMeta.accountID }/amendments/${ amendmentID }`;
        }
    };

    render() {
        const { currentAccountMeta } = this.props;

        if (!currentAccountMeta || !this.state.amendments) {
            return <Loader />;
        }

        const breadcrumbs = this._buildBreadcrumbs();

        return (
            <ContainerControlSite>
                <Header
                    subHeader="Amendments"
                    breadcrumbs={breadcrumbs}
                    selectedTitle="accounts"
                />

                <Content>
                    <Text
                        align="right"
                        bold
                    >
                        { currentAccountMeta.company } ({ currentAccountMeta.groupNum })
                    </Text>

                    <Text
                        align="right"
                        light
                    >
                        Advisor: { currentAccountMeta.advisor }
                    </Text>

                    {
                        currentAccountMeta.effDate &&
                        <Text
                            align="right"
                            light
                        >
                            Effective Date: { dates.getStartOfDay(currentAccountMeta.effDate, 'll') }
                        </Text>
                    }

                    <Text
                        align="right"
                        light
                    >
                        Secondary Policy #: { currentAccountMeta.secondaryPolicyNumber || 'None' }
                    </Text>

                    <MessageCard
                        title="Group Amendments"
                        subtitle="View all current and past amendments for the group below. Use the attached button to create a new Amendment or select an Amendment from the list for more options."
                        btn
                        btnName="Create Amendment"
                        btnOnClick={this._createAmendment}
                    />

                    <AmendmentList isMasterSite={ true } amendments={ this.state.amendments } whitelabel={{}} />
                </Content>

            </ContainerControlSite>
        );
    }
}


Amendments.propTypes = {
    currentAccountMeta: PropTypes.object
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loader: state.loader,
    currentAccountMeta: state.accounts.currentAccount.meta
});

export default (connect(mapStateToProps)(Amendments));